import React, { useEffect, useState } from "react"
import { Navbar } from "reactstrap"
import classnames from "classnames"
import NavbarBookmarks from "./NavbarBookmarks"
import NavbarUser from "./NavbarUser"
import userImg from "../../../assets/img/portrait/small/avatar-s-50.png"
import { NavLink } from "react-router-dom"
import apiConfig from "../../../configs/apiConfig.js";


const ThemeNavbar = props => {
  const [patientCaseId, setCaseId] = useState()
  useEffect(() => {
    const { location } = props
    if (location && location.state && location.state.params && location.state.params.caseId) {
      setCaseId(location.state.params.caseId)
    }
  }, [props])
  const colorsArr = [ "primary", "danger", "success", "info", "warning", "dark"]
  const navbarTypes = ["floating" , "static" , "sticky" , "hidden"]
  return (
    <React.Fragment>
      <div className="content-overlay" />
      <div className="header-navbar-shadow" />
      <Navbar
        className={classnames(
          "header-navbar navbar-expand-lg navbar navbar-with-menu navbar-shadow",
          {
            "navbar-light": props.navbarColor === "default" || !colorsArr.includes(props.navbarColor),
            "navbar-dark": colorsArr.includes(props.navbarColor),
            "bg-primary":
              props.navbarColor === "primary" && props.navbarType !== "static",
            "bg-danger":
              props.navbarColor === "danger" && props.navbarType !== "static",
            "bg-success":
              props.navbarColor === "success" && props.navbarType !== "static",
            "bg-info":
              props.navbarColor === "info" && props.navbarType !== "static",
            "bg-warning":
              props.navbarColor === "warning" && props.navbarType !== "static",
            "bg-dark":
              props.navbarColor === "dark" && props.navbarType !== "static",
            "d-none": props.navbarType === "hidden" && !props.horizontal,
            "floating-nav":
              (props.navbarType === "floating" && !props.horizontal) || (!navbarTypes.includes(props.navbarType) && !props.horizontal),
            "navbar-static-top":
              props.navbarType === "static" && !props.horizontal,
            "fixed-top": props.navbarType === "sticky" || props.horizontal,
            "scrolling": props.horizontal && props.scrolling

          }
        )}
      >
        <div className="navbar-wrapper">
          <div className="navbar-container content">
          <div className="navbar-collapse custom-navbar" id="navbar-mobile">
              
              {props.horizontal ? (
                <>
                <div className="logo">
                {/* <div className="logo d-flex align-items-center"> */}
                  {/* <div className="brand-logo mr-50"></div> */}
                 
                    <img src={apiConfig.GNS_logoURL + 'logo.png'} alt="Genesis Laboratory" width={"30%"} className="navbar-logo" />
                    </div>
                  <h2 className="navbar-title text-primary mb-0">Patient Registration Hub for Stool</h2>
                 
               </>
              ) : null}
              <NavbarUser
                
              />
            </div>
          </div>
        </div>
      </Navbar>
    </React.Fragment>
  )
}


export default ThemeNavbar
